<script lang="ts" setup>

</script>
<template>
  <div class="flex flex-col min-h-screen dark:text-ffc relative bg-ffc dark:bg-gray-800">
    <Header class="h-20 relative flex items-center p-4 lg:p-10"/>
    <NuxtPage class="flex-1 py-0 w-full relative z-[0] lg:px-10 px-4" />
    <Footer/>
    
  </div>
</template>